export enum UserRole {
  MANUFACTURER = 'MANUFACTURER',
  RECEIVER = 'RECEIVER',
}

export type WipFeature = {
  feature: string;
  config: string;
};

export type CognitoTokens = {
  access_token: string;
  id_token: string;
  refresh_token: string;
  expires_in: number;
  token_type: string;
};

export type MfaChallengeResponse = {
  challenge: true;
  challenge_name: 'SOFTWARE_TOKEN_MFA';
  session: string;
  email: string;
  message: string;
};

export type MfaSetupData = {
  secret_code: string;
  qr_code_url: string;
  email: string;
  issuer: string;
  message: string;
};

export type MfaStatus = {
  mfa_enabled: boolean;
  mfa_type?: string;
  preferred_mfa?: string;
};

export type SsoDiscoverResponse = {
  sso_available: boolean;
  provider_name?: string;
  authorization_url?: string;
  state?: string;
  message?: string;
};

export type UserType = {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  email_notification: number;
  admin: number;
  permissions: string[];
  account_id: number;
  parent_id: number | null;
  receiver_id: number | null;
  account_type: string;
  token: string;
  brand_permissions: BrandPermissions;
  roles: string[];
  account_name: string;
  intercom_user_id_key: string;
  intercom_user_hash: string;
  user_role_ids: number[];
  account_created_at: string;
  wip_features?: WipFeature[];
  auth_provider?: 'cognito' | 'mysql';
};

export type BrandPermissions = {
  parent: Parent;
  receiver: Parent;
};

export type Parent = {
  read: number[] | null;
  edit: number[] | null;
};

export type ListUser = {
  id: number;
  created_at: string;
  updated_at: string;
  first_name: string;
  last_name: string;
  email: string;
  email_notification: number;
  admin: number;
  active: number;
  user_role_ids: number[];
  brand_permissions: BrandPermission[];
  primary_user_id?: number;
};

export type PermissionGroup = {
  id: number;
  name: string;
  permissions: Permission[];
};

export interface Permission {
  id: number;
  code: string;
  name: string;
  description: string;
}

export type UserPermissionRole = {
  id: number;
  name: string;
  permission_ids: number[];
  segments: RoleSegment[];
};

export type RoleSegment = {
  segment_id: number;
  maintenance_type_id: number;
};

export type BrandPermission = {
  brand_id: number;
  maintenance_type_id: number;
};

export type UserName = {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  status_code: number;
};

// Multi-account user management types
export type AccountAssignment = {
  account_id: number;
  account_name: string;
  company_id: number;
  admin: number;
  user_role_ids: number[];
  brand_permissions: BrandPermissionWithName[];
  has_activity: boolean;
};

export type BrandPermissionWithName = {
  brand_id: number;
  brand_name: string;
  maintenance_type_id: number;
};

export type MultiAccountUser = {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  active: number;
  created_at: string;
  account_assignments: AccountAssignment[];
};

export type AdminAccount = {
  account_id: number;
  account_name: string;
  company_id: number;
};

export type AdminUsersViewResponse = {
  users: MultiAccountUser[];
  admin_accounts: AdminAccount[];
};

export type AccountBrand = {
  id: number;
  name: string;
  active: number;
};

export type AccountRole = {
  id: number;
  name: string;
  description: string;
};
